import * as products from 'app/mocks/data/catalogue/products/list'
import * as terminals from 'app/mocks/data/machines/all/terminals'
import * as managers from 'app/mocks/data/park/managers/list'
import * as sites from 'app/mocks/data/park/sites/list'
import * as konvives from 'app/mocks/data/users/konvives/list'

import { newDateFormatted } from 'app/utils/date'

import { Order, StatusOrder } from 'app/types/operations/order'

export const order301: Order = {
    id: 301,
    status: StatusOrder.enum.READY,
    konvive: konvives.konvive1,
    site: sites.site3,
    terminal: terminals.terminal1,
    price: 3,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 800,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-20)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 800,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-20)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager8,
            changes: [
                {
                    product: products.product21,
                    is_weight_quantity: true,
                    quantity: 425,
                },
                {
                    product: products.product22,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-20)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager8,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 800,
                },
            ],
        },
    ],
}

export const order302: Order = {
    id: 302,
    status: StatusOrder.enum.READY,
    phone_number: '0612345678',
    site: sites.site7,
    terminal: terminals.terminal4,
    price: 3,
    articles: [
        {
            product: products.product5,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product6,
            is_weight_quantity: true,
            quantity: 450,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-19)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0612345678',
            changes: [
                {
                    product: products.product5,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product6,
                    is_weight_quantity: true,
                    quantity: 450,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-19)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-19)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager8,
            changes: [],
        },
    ],
}

export const order303: Order = {
    id: 303,
    status: StatusOrder.enum.READY,
    konvive: konvives.konvive3,
    site: sites.site12,
    terminal: terminals.terminal2,
    price: 3,
    articles: [
        {
            product: products.product8,
            is_weight_quantity: true,
            quantity: 1_200,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-18)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive3,
            changes: [
                {
                    product: products.product5,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product6,
                    is_weight_quantity: true,
                    quantity: 450,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-18)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager5,
            changes: [
                {
                    product: products.product8,
                    is_weight_quantity: true,
                    quantity: 1_200,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-18)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager5,
            changes: [],
        },
    ],
}

export const order304: Order = {
    id: 304,
    status: StatusOrder.enum.READY,
    phone_number: '0623456789',
    site: sites.site15,
    terminal: terminals.terminal4,
    price: 3,
    articles: [
        {
            product: products.product11,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product12,
            is_weight_quantity: true,
            quantity: 600,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-17)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0623456789',
            changes: [
                {
                    product: products.product11,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product12,
                    is_weight_quantity: true,
                    quantity: 600,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-17)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-17)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager5,
            changes: [],
        },
    ],
}

export const order305: Order = {
    id: 305,
    status: StatusOrder.enum.READY,
    konvive: konvives.konvive5,
    site: sites.site19,
    terminal: terminals.terminal3,
    price: 3,
    articles: [
        {
            product: products.product15,
            is_weight_quantity: true,
            quantity: 900,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-16)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive5,
            changes: [
                {
                    product: products.product11,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product12,
                    is_weight_quantity: true,
                    quantity: 600,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-16)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager1,
            changes: [
                {
                    product: products.product15,
                    is_weight_quantity: true,
                    quantity: 900,
                },
            ],
        },
    ],
}

export const order306: Order = {
    id: 306,
    status: StatusOrder.enum.READY,
    phone_number: '0634567890',
    site: sites.site4,
    terminal: terminals.terminal1,
    price: 3,
    articles: [
        {
            product: products.product17,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-15)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0634567890',
            changes: [
                {
                    product: products.product17,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-15)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order307: Order = {
    id: 307,
    status: StatusOrder.enum.READY,
    konvive: konvives.konvive7,
    site: sites.site8,
    terminal: terminals.terminal2,
    price: 3,
    articles: [
        {
            product: products.product19,
            is_weight_quantity: true,
            quantity: 750,
        },
        {
            product: products.product20,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-14)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive7,
            changes: [
                {
                    product: products.product19,
                    is_weight_quantity: true,
                    quantity: 650,
                },
                {
                    product: products.product21,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-14)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [
                {
                    product: products.product19,
                    is_weight_quantity: true,
                    quantity: 750,
                },
                {
                    product: products.product20,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-14)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order308: Order = {
    id: 308,
    status: StatusOrder.enum.READY,
    phone_number: '0645678901',
    site: sites.site11,
    terminal: terminals.terminal4,
    price: 3,
    articles: [
        {
            product: products.product22,
            is_weight_quantity: true,
            quantity: 1_100,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-13)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0645678901',
            changes: [
                {
                    product: products.product22,
                    is_weight_quantity: true,
                    quantity: 1_100,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-13)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order309: Order = {
    id: 309,
    status: StatusOrder.enum.READY,
    konvive: konvives.konvive9,
    site: sites.site14,
    terminal: terminals.terminal3,
    price: 3,
    articles: [
        {
            product: products.product24,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-12)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive9,
            changes: [
                {
                    product: products.product24,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager9,
            changes: [
                {
                    product: products.product24,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-12)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager9,
            changes: [],
        },
    ],
}

export const order310: Order = {
    id: 310,
    status: StatusOrder.enum.READY,
    phone_number: '0656789012',
    site: sites.site17,
    terminal: terminals.terminal1,
    price: 3,
    articles: [
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 850,
        },
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-11)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0656789012',
            changes: [
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 850,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-11)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-11)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager9,
            changes: [],
        },
    ],
}

export const order311: Order = {
    id: 311,
    status: StatusOrder.enum.READY,
    konvive: konvives.konvive2,
    site: sites.site20,
    terminal: terminals.terminal3,
    price: 3,
    articles: [
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 950,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-10)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 850,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-10)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager3,
            changes: [
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 950,
                },
            ],
        },
    ],
}

export const order312: Order = {
    id: 312,
    status: StatusOrder.enum.READY,
    phone_number: '0667890123',
    site: sites.site2,
    terminal: terminals.terminal3,
    price: 3,
    articles: [
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 5,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-9)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0667890123',
            changes: [
                {
                    product: products.product7,
                    is_weight_quantity: false,
                    quantity: 5,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-9)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager3,
            changes: [],
        },
    ],
}

export const order313: Order = {
    id: 313,
    status: StatusOrder.enum.READY,
    konvive: konvives.konvive4,
    site: sites.site5,
    terminal: terminals.terminal3,
    price: 3,
    articles: [
        {
            product: products.product9,
            is_weight_quantity: true,
            quantity: 700,
        },
        {
            product: products.product10,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-8)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive4,
            changes: [
                {
                    product: products.product7,
                    is_weight_quantity: false,
                    quantity: 5,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-8)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager2,
            changes: [
                {
                    product: products.product9,
                    is_weight_quantity: true,
                    quantity: 700,
                },
                {
                    product: products.product10,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-8)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order314: Order = {
    id: 314,
    status: StatusOrder.enum.READY,
    phone_number: '0678901234',
    site: sites.site9,
    terminal: terminals.terminal2,
    price: 3,
    articles: [
        {
            product: products.product12,
            is_weight_quantity: true,
            quantity: 1_300,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-7)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0678901234',
            changes: [
                {
                    product: products.product12,
                    is_weight_quantity: true,
                    quantity: 1_300,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-7)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order315: Order = {
    id: 315,
    status: StatusOrder.enum.READY,
    konvive: konvives.konvive6,
    site: sites.site13,
    terminal: terminals.terminal2,
    price: 3,
    articles: [
        {
            product: products.product14,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-6)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive6,
            changes: [
                {
                    product: products.product12,
                    is_weight_quantity: true,
                    quantity: 1_300,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-6)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager7,
            changes: [
                {
                    product: products.product14,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-6)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order316: Order = {
    id: 316,
    status: StatusOrder.enum.READY,
    phone_number: '0689012345',
    site: sites.site16,
    terminal: terminals.terminal4,
    price: 3,
    articles: [
        {
            product: products.product16,
            is_weight_quantity: true,
            quantity: 550,
        },
        {
            product: products.product17,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-5)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0689012345',
            changes: [
                {
                    product: products.product16,
                    is_weight_quantity: true,
                    quantity: 550,
                },
                {
                    product: products.product17,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-5)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order317: Order = {
    id: 317,
    status: StatusOrder.enum.READY,
    konvive: konvives.konvive8,
    site: sites.site18,
    terminal: terminals.terminal1,
    price: 3,
    articles: [
        {
            product: products.product19,
            is_weight_quantity: true,
            quantity: 1_150,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-4)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive8,
            changes: [
                {
                    product: products.product16,
                    is_weight_quantity: true,
                    quantity: 550,
                },
                {
                    product: products.product17,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-4)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-4)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager4,
            changes: [
                {
                    product: products.product19,
                    is_weight_quantity: true,
                    quantity: 1_150,
                },
            ],
        },
    ],
}

export const order318: Order = {
    id: 318,
    status: StatusOrder.enum.READY,
    phone_number: '0690123456',
    site: sites.site21,
    terminal: terminals.terminal1,
    price: 3,
    articles: [
        {
            product: products.product21,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-3)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0690123456',
            changes: [
                {
                    product: products.product21,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-3)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order319: Order = {
    id: 319,
    status: StatusOrder.enum.READY,
    konvive: konvives.konvive10,
    site: sites.site6,
    terminal: terminals.terminal3,
    price: 3,
    articles: [
        {
            product: products.product23,
            is_weight_quantity: true,
            quantity: 650,
        },
        {
            product: products.product24,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-2)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive10,
            changes: [
                {
                    product: products.product21,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-2)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager10,
            changes: [
                {
                    product: products.product23,
                    is_weight_quantity: true,
                    quantity: 650,
                },
                {
                    product: products.product24,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-2)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager10,
            changes: [],
        },
    ],
}

export const order320: Order = {
    id: 320,
    status: StatusOrder.enum.READY,
    phone_number: '0601234567',
    site: sites.site10,
    terminal: terminals.terminal1,
    price: 3,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 900,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-1)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0601234567',
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 900,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-1)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T12:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager10,
            changes: [],
        },
    ],
}
